"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/styles");

var _notistack = require("notistack");

var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));

var _material = require("@mui/material");

var _Notifications = _interopRequireDefault(require("@mui/icons-material/Notifications"));

var _reactRouterDom = require("react-router-dom");

var _styles2 = require("@mui/material/styles");

var _Theme = require("material-ui-shell/lib/providers/Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _root;

  return {
    root: (_root = {}, _root[theme.breakpoints.up('sm')] = {
      minWidth: '344px !important'
    }, _root.maxWidth = 400, _root.cursor = 'pointer', _root),
    card: {
      width: '100%'
    }
  };
});

var SnackMessage = _react.default.forwardRef(function (props, ref) {
  var classes = useStyles();
  var navigate = (0, _reactRouterDom.useNavigate)();

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      closeSnackbar = _useSnackbar.closeSnackbar;

  var payload = props.payload,
      id = props.id;
  var notification = payload.notification;

  var _ref = notification || {},
      title = _ref.title,
      body = _ref.body,
      icon = _ref.icon,
      image = _ref.image,
      click_action = _ref.click_action; // const theme = useTheme()
  // const type = theme.palette.type === 'light' ? 'dark' : 'light'


  var _useAppTheme = (0, _Theme.useTheme)(),
      isDarkMode = _useAppTheme.isDarkMode;

  var innerTheme = (0, _styles2.createTheme)({
    palette: {
      type: isDarkMode ? 'light' : 'dark'
    }
  });

  var handleDismiss = function handleDismiss() {
    closeSnackbar(id);
  };

  var handleClick = function handleClick() {
    var url = new URL(click_action);
    navigate(url.pathname);
    handleDismiss();
  };

  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: innerTheme
  }, /*#__PURE__*/_react.default.createElement(_notistack.SnackbarContent, {
    ref: ref,
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_material.Card, {
    className: classes.card
  }, image && /*#__PURE__*/_react.default.createElement(_material.CardMedia, {
    onClick: handleClick,
    style: {
      height: 140
    },
    image: image,
    title: title
  }), /*#__PURE__*/_react.default.createElement(_material.CardHeader, {
    avatar: /*#__PURE__*/_react.default.createElement(_material.Avatar, {
      onClick: handleClick,
      src: icon,
      "aria-label": "recipe"
    }, /*#__PURE__*/_react.default.createElement(_Notifications.default, null)),
    action: /*#__PURE__*/_react.default.createElement(_material.IconButton, {
      onClick: handleDismiss,
      style: {
        zIndex: 9999
      },
      className: classes.expand
    }, /*#__PURE__*/_react.default.createElement(_Close.default, null)),
    title: /*#__PURE__*/_react.default.createElement("div", {
      onClick: handleClick
    }, title),
    subheader: /*#__PURE__*/_react.default.createElement("div", {
      onClick: handleClick
    }, body)
  }))));
});

var _default = SnackMessage;
exports.default = _default;
module.exports = exports.default;